
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getVerifyOtpV2DtoFormGroup() {
return new FormGroup({
    username: new FormControl<string | undefined>(''),
    appAccessCode: new FormControl<string | undefined>(''),
    emailId: new FormControl<number | undefined>(undefined),
    phoneId: new FormControl<number | undefined>(undefined),
    otp: new FormControl<string | undefined>('', [Validators.required]),
    mobileNumber: new FormControl<string | undefined>(''),
})
;
}
      